import React, { FC, useEffect, useState } from 'react';
import { ArrowsAltOutlined } from '@ant-design/icons';
import { Col, Input, message, Row, Select } from 'antd';
import { Page, Document, pdfjs } from 'react-pdf';
import { api, endpoints } from '../../../../api';
import { FourLinesCollapse, LeftArrowSvg, RightArrowSvg } from '../../../../icons';
import {
  BlueLayout,
  CustomButton,
  CustomModal,
  CustomSelect,
  ExpertiseComponentContainer,
  FormBlock,
  FormContainer,
  FormInput,
  GridItem,
  TextLink,
} from '../../../../styles/styled';
import { ExpertModelQues } from '../../../ExpertExpertisePage/components/ExpertModel/ExpertModalQues';
import { ExpertiseType } from '../../../ExpertisePage/types';
import {
  ExpertiseListFeedback,
  ExpertiseListFeedbacks,
  ExpertiseListsContainer,
  PovsExpertiseRightSideContainer,
} from '../../styled';
import { CollapsableItemsType, ExpertiseExpertListType, expertisePovsScores } from '../../types';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

type PovsExpertisesToolbarProps = {
  expertise?: ExpertiseType;
  expertise_list?: ExpertiseExpertListType;
  setOpenBook: (value: string | null) => void;
};

const { Option } = Select;
const { TextArea } = Input;

export const PovsExpertisesToolbar: FC<PovsExpertisesToolbarProps> = ({ expertise, setOpenBook, expertise_list }) => {
  const [currentBook, setCurrentBook] = useState<string>('');
  const [pdfPageState, setPdfPage] = useState<number>(1);
  const [maxPdfPages, setMaxPdfPages] = useState<number>(1);
  const [pageInput, setPageInput] = useState<number | null>(null);
  const [expertListInputState, setExpertListInput] = useState<ExpertiseExpertListType>({});
  const [expertListChangesState, setExpertListChangesInput] = useState<ExpertiseExpertListType | undefined>();
  const [collapsableItemsState, setCollapsableItems] = useState<CollapsableItemsType>();
  const [isUserSureModalCollapse, setIsUserSureModalCollapse] = useState<boolean>(false);

  useEffect(
    () => {
      if (expertise_list) setExpertListInput(expertise_list);
    },
    // eslint-disable-next-line
    [],
  );
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (expertise)
      setCurrentBook(
        expertise?.textbook?.file_textbook?.file_path ||
          expertise?.textbook?.file_instruction?.file_path ||
          expertise?.textbook?.file_guideline?.file_path,
      );
  }, [expertise]);

  const updateExpertiseList = async () => {
    if (expertise?.expertise_list && expertListInputState !== null) {
      try {
        const response = await api.put(
          endpoints.putExpertiseList(expertise?.expertise_list?.id),
          expertise_list ? expertListChangesState : expertListInputState,
        );

        if (response) {
          api.get(endpoints.getExpertiseListPdfById(expertise?.expertise_list?.id));

          api
            .put(endpoints.sendExpertiseListToFo(expertise?.expertise_list?.id))
            .then(() => message.success('Данные успешно обновлены'));
        }
      } catch (err) {}
    }
  };

  const checkScoresFill = () => {
    if (
      !Object.keys(expertisePovsScores)
        .map((el) => Object.keys(expertListInputState).includes(el))
        .includes(false)
    )
      updateExpertiseList();
    else message.error('Невозможно подтвердить экспертный лист, все критерии должны быть заполнены');
  };

  return (
    <ExpertiseComponentContainer>
      <FormContainer columns padding="15px" background={'#ffffff'}>
        <div className="column-block">
          <Row gutter={[10, 10]}>
            <Col span={24}>
              <BlueLayout fontsize="16.5px" padding="0" weight="500">
                Индивидуальный лист эксперта
              </BlueLayout>
            </Col>
            <Col span={24}>
              <GridItem align="center" gap="20px" justify="flex-start" direction="row" wrap="nowrap">
                <div className="text no-wrap">ФИО эксперта</div>
                <FormInput
                  value={expertListInputState?.fio}
                  onChange={(e) => {
                    setExpertListChangesInput({ ...expertListChangesState, fio: e.target.value });
                    setExpertListInput({ ...expertListInputState, fio: e.target.value });
                  }}
                  width="100%"
                />
              </GridItem>
            </Col>
            <Col />
            <Col span={24}>
              <GridItem align="center" justify="flex-start" direction="row" gap="10px">
                <FourLinesCollapse />
                <TextLink onClick={() => setCollapsableItems({})}>Свернуть все ответы</TextLink>
              </GridItem>
            </Col>
          </Row>
          <br />
          <ExpertiseListsContainer>
            <ExpertiseListFeedbacks border>
              <div className="text">
                3.1. В содержании учебника и разработанных в комплекте с ним учебных пособий отражены национальные
                российские ценности, региональные и этнокультурные особенности субъекта Российской Федерации, а также
                многообразие, единство национальных культур и народов России, поликультурный характер российского
                общества.
              </div>
              <button
                className="link"
                onClick={() =>
                  setCollapsableItems({
                    ...collapsableItemsState,
                    national_value: !collapsableItemsState?.national_value,
                  })
                }
              >
                Ответить
              </button>
              {collapsableItemsState?.national_value && (
                <ExpertiseListFeedback>
                  <div className="grade">Экспертная оценка по критерию</div>
                  <CustomSelect
                    value={expertListInputState?.national_values_is_present_povs}
                    onChange={(value) => {
                      setExpertListInput({
                        ...expertListInputState,
                        national_values_is_present_povs: value as string,
                      });
                      setExpertListChangesInput({
                        ...expertListChangesState,
                        national_values_is_present_povs: value as string,
                      });
                    }}
                    width="100px"
                  >
                    <Option key={0} value={0}>
                      0
                    </Option>
                    <Option key={1} value={1}>
                      1
                    </Option>
                    <Option key={2} value={2}>
                      2
                    </Option>
                    <Option key={3} value={3}>
                      3
                    </Option>
                  </CustomSelect>

                  <div className="grade">Комментарий:</div>
                  <TextArea
                    value={expertListInputState?.national_values_is_present_povscomment}
                    onChange={(e) => {
                      setExpertListInput({
                        ...expertListInputState,
                        national_values_is_present_povscomment: e.target.value,
                      });
                      setExpertListChangesInput({
                        ...expertListChangesState,
                        national_values_is_present_povscomment: e.target.value,
                      });
                    }}
                  />
                </ExpertiseListFeedback>
              )}
            </ExpertiseListFeedbacks>
            <ExpertiseListFeedbacks border>
              <div className="text">
                3.2. В содержании учебника и разработанных в комплекте с ним учебных пособий представлен материал по
                истории и культурному наследию соответствующего субъекта Российской Федерации.
              </div>
              <button
                className="link"
                onClick={() =>
                  setCollapsableItems({
                    ...collapsableItemsState,
                    corresponding_region: !collapsableItemsState?.corresponding_region,
                  })
                }
              >
                Ответить
              </button>
              {collapsableItemsState?.corresponding_region && (
                <ExpertiseListFeedback>
                  <div className="grade">Экспертная оценка по критерию</div>
                  <CustomSelect
                    value={expertListInputState?.corresponding_region_history_povs}
                    onChange={(value) => {
                      setExpertListInput({
                        ...expertListInputState,
                        corresponding_region_history_povs: value as string,
                      });

                      setExpertListChangesInput({
                        ...expertListChangesState,
                        corresponding_region_history_povs: value as string,
                      });
                    }}
                    width="100px"
                  >
                    <Option key={0} value={0}>
                      0
                    </Option>
                    <Option key={1} value={1}>
                      1
                    </Option>
                    <Option key={2} value={2}>
                      2
                    </Option>
                    <Option key={3} value={3}>
                      3
                    </Option>
                  </CustomSelect>

                  <div className="grade">Комментарий:</div>
                  <TextArea
                    value={expertListInputState?.corresponding_region_history_povscomment}
                    onChange={(e) => {
                      setExpertListInput({
                        ...expertListInputState,
                        corresponding_region_history_povscomment: e.target.value,
                      });

                      setExpertListChangesInput({
                        ...expertListChangesState,
                        corresponding_region_history_povscomment: e.target.value,
                      });
                    }}
                  />
                </ExpertiseListFeedback>
              )}
            </ExpertiseListFeedbacks>
            <ExpertiseListFeedbacks border>
              <div className="text">
                3.3. Отсутствие в содержании учебника и разработанных в комплекте с ним учебных пособий материалов,
                актуализирующих межнациональные, межэтнические конфликты, превосходство одного народа (национальности)
                над другим.
              </div>
              <button
                className="link"
                onClick={() =>
                  setCollapsableItems({
                    ...collapsableItemsState,
                    national_conflicts: !collapsableItemsState?.national_conflicts,
                  })
                }
              >
                Ответить
              </button>
              {collapsableItemsState?.national_conflicts && (
                <ExpertiseListFeedback>
                  <div className="grade">Экспертная оценка по критерию</div>
                  <CustomSelect
                    value={expertListInputState?.no_national_conflict_povs}
                    onChange={(value) => {
                      setExpertListInput({
                        ...expertListInputState,
                        no_national_conflict_povs: value as string,
                      });

                      setExpertListChangesInput({
                        ...expertListChangesState,
                        no_national_conflict_povs: value as string,
                      });
                    }}
                    width="100px"
                  >
                    <Option key={0} value={0}>
                      0
                    </Option>
                    <Option key={1} value={1}>
                      1
                    </Option>
                    <Option key={2} value={2}>
                      2
                    </Option>
                    <Option key={3} value={3}>
                      3
                    </Option>
                  </CustomSelect>

                  <div className="grade">Комментарий:</div>
                  <TextArea
                    value={expertListInputState?.no_national_conflict_povscomment}
                    onChange={(e) => {
                      setExpertListInput({
                        ...expertListInputState,
                        no_national_conflict_povscomment: e.target.value,
                      });

                      setExpertListChangesInput({
                        ...expertListChangesState,
                        no_national_conflict_povscomment: e.target.value,
                      });
                    }}
                  />
                </ExpertiseListFeedback>
              )}
            </ExpertiseListFeedbacks>
            <ExpertiseListFeedbacks border>
              <div className="text">
                3.4. Языковая составляющая учебника и разработанных в комплекте с ним учебных пособий соответствует
                современному литературному языку народов Российской Федерации.
              </div>
              <button
                className="link"
                onClick={() =>
                  setCollapsableItems({
                    ...collapsableItemsState,
                    lit_language: !collapsableItemsState?.lit_language,
                  })
                }
              >
                Ответить
              </button>
              {collapsableItemsState?.lit_language && (
                <ExpertiseListFeedback>
                  <div className="grade">Экспертная оценка по критерию</div>
                  <CustomSelect
                    value={expertListInputState?.lit_language_is_present_povs}
                    onChange={(value) => {
                      setExpertListInput({
                        ...expertListInputState,
                        lit_language_is_present_povs: value as string,
                      });

                      setExpertListChangesInput({
                        ...expertListChangesState,
                        lit_language_is_present_povs: value as string,
                      });
                    }}
                    width="100px"
                  >
                    <Option key={0} value={0}>
                      0
                    </Option>
                    <Option key={1} value={1}>
                      1
                    </Option>
                    <Option key={2} value={2}>
                      2
                    </Option>
                    <Option key={3} value={3}>
                      3
                    </Option>
                  </CustomSelect>

                  <div className="grade">Комментарий:</div>
                  <TextArea
                    value={expertListInputState?.lit_language_is_present_povscomment}
                    onChange={(e) => {
                      setExpertListInput({
                        ...expertListInputState,
                        lit_language_is_present_povscomment: e.target.value,
                      });

                      setExpertListChangesInput({
                        ...expertListChangesState,
                        lit_language_is_present_povscomment: e.target.value,
                      });
                    }}
                  />
                </ExpertiseListFeedback>
              )}
            </ExpertiseListFeedbacks>
            <ExpertiseListFeedbacks>
              <div className="text">
                4.1. Учебник и разработанных в комплекте с ним учебных пособий рекомендован к включению в федеральный
                перечень учебников.
              </div>
              <button
                className="link"
                onClick={() =>
                  setCollapsableItems({
                    ...collapsableItemsState,
                    recommended: !collapsableItemsState?.recommended,
                  })
                }
              >
                Ответить
              </button>
              {collapsableItemsState?.recommended && (
                <ExpertiseListFeedback>
                  <div className="grade">Экспертная оценка по критерию</div>
                  <CustomSelect
                    value={expertListInputState?.recommended_povs}
                    onChange={(value) => {
                      setExpertListInput({
                        ...expertListInputState,
                        recommended_povs: value as string,
                      });

                      setExpertListChangesInput({
                        ...expertListChangesState,
                        recommended_povs: value as string,
                      });
                    }}
                    width="100px"
                  >
                    <Option key={0} value={'Да'}>
                      Да
                    </Option>
                    <Option key={1} value={'Нет'}>
                      Нет
                    </Option>
                  </CustomSelect>

                  <div className="grade">Комментарий:</div>
                  <TextArea
                    value={expertListInputState?.recommended_povscomment}
                    onChange={(e) => {
                      setExpertListInput({
                        ...expertListInputState,
                        recommended_povscomment: e.target.value,
                      });

                      setExpertListChangesInput({
                        ...expertListChangesState,
                        recommended_povscomment: e.target.value,
                      });
                    }}
                  />
                </ExpertiseListFeedback>
              )}
            </ExpertiseListFeedbacks>
          </ExpertiseListsContainer>
        </div>
        <div className="column-block">
          <PovsExpertiseRightSideContainer>
            <CustomSelect
              onChange={(value) => {
                setPdfPage(1);
                const selectedValue = value as string;

                switch (value as string) {
                  case 'file_textbook':
                    setCurrentBook(expertise?.textbook?.file_textbook?.file_path || '');

                    return;
                  case 'file_instruction':
                    setCurrentBook(expertise?.textbook?.file_instruction?.file_path || '');

                    return;
                  case 'file_guideline':
                    setCurrentBook(expertise?.textbook?.file_guideline?.file_path || '');

                    return;

                  default:
                    if (selectedValue.startsWith('manual_file')) {
                      const index = parseInt(selectedValue.substring(11));
                      setCurrentBook(expertise?.textbook?.text_book_edu_man[index]?.file?.file_path || '');
                    }

                    return;
                }
              }}
              defaultValue="Учебник в электронном формате"
            >
              {expertise?.textbook?.file_textbook && (
                <Option value="file_textbook" key="file_textbook">
                  Учебник в электронном формате
                </Option>
              )}
              {expertise?.textbook?.file_instruction && (
                <Option value="file_instruction" key="file_instruction">
                  Интсрукция по установке, настройке и использованию электронной формы учебника
                </Option>
              )}
              {expertise?.textbook?.file_guideline && (
                <Option value="file_guideline" key="file_guideline">
                  Методическое пособие для учителя
                </Option>
              )}
              {expertise?.textbook?.text_book_edu_man?.map(
                (el, idx) =>
                  el.file?.file_path && (
                    <Option value={`manual_file${idx}`} key={`manual_file${idx}`}>
                      {`Учебное пособие ${el.title}`}
                    </Option>
                  ),
              )}
            </CustomSelect>
            <FormBlock>
              <div style={{ height: '500px', display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
                <Document
                  file={{ url: currentBook }}
                  onLoadSuccess={({ numPages }) => setMaxPdfPages(numPages)}
                  renderMode="canvas"
                >
                  <Page width={350} height={400} pageNumber={pdfPageState} />
                </Document>
              </div>
              <GridItem direction="row" align="center" justify="center" gap="10px">
                <CustomButton
                  padding="8px 10px"
                  lined
                  onClick={() => {
                    if (pdfPageState < maxPdfPages) setPdfPage(pdfPageState - 1);

                    if (pageInput) setPageInput(null);
                  }}
                >
                  <div style={{ height: '15px' }}>
                    <LeftArrowSvg />
                  </div>
                </CustomButton>
                <FormInput
                  type="number"
                  onChange={(e) =>
                    setPageInput(parseInt(e.target.value) > maxPdfPages ? maxPdfPages : parseInt(e.target.value))
                  }
                  width="90px"
                  value={pageInput || pdfPageState}
                />
                <CustomButton
                  width="400px"
                  padding="5px 10px"
                  lined
                  flex
                  onClick={() => {
                    if (pdfPageState < maxPdfPages) setPdfPage(pageInput ? pageInput : pdfPageState + 1);

                    if (pageInput) setPageInput(null);
                  }}
                >
                  перейти
                  <div style={{ height: '15px' }}>
                    <RightArrowSvg />
                  </div>
                </CustomButton>
                <div className="text">из {maxPdfPages}</div>
                <CustomButton onClick={() => setOpenBook(currentBook)} lined padding="5px 15px">
                  <ArrowsAltOutlined />
                </CustomButton>
              </GridItem>
            </FormBlock>
          </PovsExpertiseRightSideContainer>
        </div>
        <br />

        <GridItem direction="row" gap="35px" align="center" justify="center">
          <CustomButton
            disabled={!expertListInputState}
            disable={!expertListInputState}
            onClick={() => setOpen(true)}
            lined
          >
            Посмотреть
          </CustomButton>
          {<ExpertModelQues open={open} setOpen={(value) => setOpen(value)} povsQuestion={expertListInputState} />}
          <CustomButton onClick={checkScoresFill}> Отправить</CustomButton>
        </GridItem>
      </FormContainer>

      <CustomModal
        showCancelButton
        title=""
        centered
        okText="Добавить"
        cancelText="Отклонить"
        visible={isUserSureModalCollapse}
        onCancel={() => setIsUserSureModalCollapse(false)}
        onOk={() => updateExpertiseList()}
        width={600}
      >
        <div className="big-text">Вы уверены что, что хотите отправить индивидуальный лист эксперта?</div>
      </CustomModal>
    </ExpertiseComponentContainer>
  );
};
